import { IconButton, makeStyles, theme } from '@archer-technologies/ui-components';
import { TableTreeColumn } from '@devexpress/dx-react-grid-material-ui';
import * as React from 'react';

const useStyles = makeStyles(() => {
  return {
    gridExpandButtonIcon: {
      color: theme.palette.grey[900]
    },
    hiddenButton: {
      visibility: 'hidden'
    }
  };
});

const treeExpandIcon =
  (gridTranslations: any) =>
  ({ expanded, onToggle, visible }: TableTreeColumn.ExpandButtonProps) => {
    const { gridExpandButtonIcon, hiddenButton } = useStyles();
    const { groupIconExpandLabel, groupIconCollapseLabel } = gridTranslations;

    return (
      <IconButton
        icon={expanded ? 'ArrowDropDown' : 'ArrowRight'}
        label={expanded ? groupIconCollapseLabel : groupIconExpandLabel}
        onClick={onToggle}
        className={visible ? `${gridExpandButtonIcon}` : `${gridExpandButtonIcon} ${hiddenButton}`}
        tabIndex={visible ? 0 : -1}
      />
    );
  };

export { treeExpandIcon };
